<template>
  <Picker
    set="facebook"
    :data="emojiIndex"
    :emoji-size="24"
    :per-line="8"
    :native="false"
    :emojis-to-show-filter="emojisToShowFilter"
    :infinite-scroll="true"
    @select="addEmoji"
  />
</template>

<script>
import data from 'emoji-mart-vue-fast/data/all.json';

import { Picker, EmojiIndex } from 'emoji-mart-vue-fast';

// Import CSS with default styles:
import 'emoji-mart-vue-fast/css/emoji-mart.css';

export default {
  components: {
    Picker,
  },

  data() {
    // https://kapeli.com/cheat_sheets/Emoji.docset/Contents/Resources/Documents/index
    return {
      emojiIndex: new EmojiIndex(data),
      emojiFilter: {
        // '1F604': true,
        // '1F603': true,
        // '1F600': true,
        // '1F60A': true,
        // '263A': true,
        // '1F609': true,
        // '1F60D': true,
        // '1F618': true,
        // '1F61A': true,
        // '1F617': true,
        // '1F619': true,
        // '1F61C': true,
        // '1F61D': true,
        // '1F61B': true,
        // '1F633': true,
        // '1F601': true,
        // '1F614': true,
        // '1F60C': true,
        // '1F612': true,
        // '1F61E': true,
        // '1F623': true,
        // '1F622': true,
        // '1F602': true,
        // '1F62D': true,
        // '1F62A': true,
        // '1F625': true,
        // '1F630': true,
        // '1F605': true,
        // '1F613': true,
        // '1F629': true,
        // '1F62B': true,
        // '1F628': true,
        // '1F631': true,
        // '1F620': true,
        // '1F621': true,
        // '1F624': true,
        // '1F616': true,
        // '1F606': true,
        // '1F60B': true,
        // '1F637': true,
        // '1F60E': true,
        // '1F634': true,
        // '1F635': true,
        // '1F632': true,
        // '1F61F': true,
        // '1F626': true,
        // '1F627': true,
        // '1F608': true,
        // '1F47F': true,
        // '1F62E': true,
        // '1F62C': true,
        // '1F610': true,
        // '1F615': true,
        // '1F62F': true,
        // '1F636': true,
        // '1F607': true,
        // '1F60F': true,
        // '1F611': true,
        // '1F49B': true,
        // '1F499': true,
        // '1F49C': true,
        // '1F49A': true,
        // 2764: true,
        // '1F494': true,
        // '1F497': true,
        // '1F493': true,
        // '1F495': true,
        // '1F496': true,
        // '1F49E': true,
        // '1F498': true,
        // '1F48C': true,
        // '1F48B': true,
        // '1F48D': true,
        // '1F48E': true,
        // '1F389': true,

        // // ariele's picks
        // '1F648': true,
        // '1F649': true,
        // '1F64A': true,
        // '1F63A': true,
        // '1F638': true,
        // '1F63B': true,
        // '1F63D': true,
        // '1F63C': true,
        // '1F640': true,
        // '1F63F': true,
        // '1F639': true,
        // '1F63E': true,
        // '1F4A9': true,
        // '1F525': true,
        // '1F31F': true,
        // '1F4AB': true,
        // '1F4A6': true,
        // '1F4A4': true,
        // '1F445': true,
        // '1F444': true,
        // '1F44D': true,
        // '1F44E': true,
        // '1F44C': true,
        // '270C': true,
        // '1F44B': true,
        // '1F64F': true,
        // '1F4AA': true,
        // '1F3C3': true,
        // '1F483': true,
      },
    };
  },

  methods: {
    emojisToShowFilter(emoji) {
      if (typeof this.emojiFilter[emoji.unified] !== 'undefined') return true;

      return false;
    },

    addEmoji(emoji) {
      this.$emit('addEmoji', emoji);
    },
  },
};
</script>

<style>
.emoji-mart-bar,
.emoji-mart-search {
  display: none;
}
.emoji-mart-scroll {
  border-bottom: 0;
  margin-bottom: 6px;
}

.emoji-mart-scroll + .emoji-mart-bar {
  display: none;
}

.emoji-mart {
  max-height: 400px;
  z-index: 1;
  position: absolute;
  bottom: 80%;
  right: 30%;
}
</style>
